<template>
  <div class="countdown-widget" :style="style">
    <div class="count-down">
      <div class="timer">
        <div class="minutes">
          <div class="value">
            <div class="digit">{{ getSinglesDigitFromNumber(dateToCountDownObject.minutes) }}</div>
            <div class="digit">{{ getTensDigitFromNumber(dateToCountDownObject.minutes) }}</div>
          </div>
          <div class="label">דקות</div>
        </div>
        <div class="colon">:</div>
        <div class="hours">
          <div class="value">
            <div class="digit">{{ getSinglesDigitFromNumber(dateToCountDownObject.hours) }}</div>
            <div class="digit">{{ getTensDigitFromNumber(dateToCountDownObject.hours) }}</div>
          </div>

          <div class="label">שעות</div>
        </div>
        <div class="colon">:</div>
        <div class="days">
          <div class="value">
            <div class="digit">{{ getSinglesDigitFromNumber(dateToCountDownObject.days) }}</div>
            <div class="digit">{{ getTensDigitFromNumber(dateToCountDownObject.days) }}</div>
          </div>
          <div class="label">ימים</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'CountdownWidgetView',
  props: {
    widget: {
      type: Object,
    },
  },
  computed: {
    style() {
      return {
        left: this.widget.left === 'unset' ? this.widget.left : `${this.widget.left}px`,
        right: this.widget.right === 'unset' ? this.widget.right : `${this.widget.right}px`,
        top: `${this.widget.top}px`,
        transform: `rotate(${this.widget.rotate}deg)`,
        zIndex: this.widget.zIndex,
      };
    },
    dateToCountDownObject() {
      return {
        days: moment(this.widget.date).diff(moment(), 'days'),
        hours: moment().endOf('day').diff(moment(), 'hours'),
        minutes: moment().endOf('hour').diff(moment(), 'minutes'),
      };
    },
  },
  methods: {
    getTensDigitFromNumber(number) {
      const numberString = this.numberToTwoDigitsString(number);
      return this.getTensDigitFromNumberString(numberString);
    },
    getTensDigitFromNumberString(numberString) {
      return numberString.split('')[0];
    },
    getSinglesDigitFromNumber(number) {
      const numberString = this.numberToTwoDigitsString(number);
      return this.getSinglesDigitFromNumberString(numberString);
    },
    getSinglesDigitFromNumberString(numberString) {
      return numberString.split('')[1];
    },
    numberToTwoDigitsString(number) {
      return number < 10 ? `0${number}` : number.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.countdown-widget {
  position: absolute;
  display: flex;
  direction: ltr;
  .count-down {
    border-radius: 10px;
    color: $riseup_dark_blue;
    text-align: center;
    font-size: 26px;
    font-weight: bold;

    .timer {
      display: flex;
      flex-direction: row-reverse;
      justify-content: center;
      font-size: 47px;

      .colon {
        margin-top: 10px;
        font-weight: bold;
        color: $riseup_white;
      }

      .label {
        font-size: 14px;
        font-weight: normal;
      }

      .value {
        display: flex;
        flex-direction: row-reverse;
        margin: 6px;

        .digit {
          font-family: PauzaBold;
          margin: 0px 2.5px;
          padding: 9px 5px 0px;
          min-width: 27px;
          border-radius: 5px;
          background-color: $riseup_white;
          color: $riseup_red;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
